module.exports = __webpack_public_path__ + "img/tl2.6f71bb1a.png";